const footerLinks = {
  sports: {
    title: '热门赛事',
    links: [
      { label: '足球竞猜', href: '/category/football' },
      { label: '篮球竞猜', href: '/category/basketball' },
      { label: '网球竞猜', href: '/category/tennis' },
      { label: '电子竞技', href: '/category/esports' },
    ],
  },
  platform: {
    title: '平台信息',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '品牌介绍', href: '/about#brand' },
      { label: '信誉保障', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
  guide: {
    title: '新手指南',
    links: [
      { label: '注册教程', href: '/article/register-guide' },
      { label: '充值指南', href: '/article/deposit-guide' },
      { label: '提现说明', href: '/article/withdraw-guide' },
      { label: '常见问题', href: '/#faq' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <a href="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-primary-400">
                KAIYUN
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              kaiyun.com 是领先的综合性体育娱乐平台，致力于为全球用户提供安全、流畅、专业的在线体育赛事竞猜与娱乐服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4 tracking-wide">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} kaiyun.com 版权所有。本站仅支持18岁以上用户访问，请理性娱乐。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}